"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardTag = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../../helpers");

var _BorderBox = require("../BorderBox");

var _Typography = require("../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * `CardTag` is used for the Cards, and is controlled by their `tag` prop.
 */
var CardTag = function CardTag(_ref) {
  var text = _ref.text,
      textColor = _ref.textColor,
      bgColor = _ref.color,
      borderColor = _ref.borderColor,
      position = _ref.position,
      top = _ref.top,
      left = _ref.left;
  return _react.default.createElement(_BorderBox.BorderBox, {
    borderRadius: "2",
    overflow: "hidden",
    backgroundColor: (0, _helpers.color)(bgColor) || bgColor,
    borderColor: (0, _helpers.color)(borderColor) || borderColor,
    m: 0,
    p: 0,
    position: position,
    top: top,
    left: left
  }, _react.default.createElement(_Typography.Sans, {
    size: "2",
    px: 0.5,
    py: 0.3,
    color: textColor
  }, text));
};

exports.CardTag = CardTag;
CardTag.displayName = "CardTag";
//# sourceMappingURL=CardTag.js.map